export class NumericRange {
    constructor(
        private from: number,
        private to: number
    ) { }

    intersects(value: number): boolean {
        return value >= this.from && value <= this.to;
    }
}